import { useCallback, useEffect, useRef, useState, useMemo, } from 'react';
export const useFormSearchWithDropdown = ({ searchInput, setSearchInput, onSearch, delay, optionsList, }) => {
    const inputRef = useRef(null);
    const [isFocused, setFocused] = useState(false);
    const triggerSearch = useCallback((searchValue) => {
        if (searchValue && searchValue !== '') {
            onSearch(searchValue);
            return;
        }
        onSearch(undefined);
    }, [onSearch]);
    const handleClear = () => {
        setSearchInput('');
        setFocused(false);
        onSearch(undefined);
    };
    const handleEnter = useCallback((e) => {
        e.preventDefault();
        triggerSearch(searchInput);
    }, [searchInput, triggerSearch]);
    const handleClickOptions = useCallback((option) => {
        setSearchInput(option);
        triggerSearch(option);
        setFocused(false);
    }, [setSearchInput, triggerSearch]);
    const handleInputChange = useCallback((e) => {
        if (e.target.value === '') {
            setFocused(false);
        }
        else {
            setFocused(true);
        }
        setSearchInput(e.target.value);
    }, [setSearchInput]);
    const filteredList = useMemo(() => {
        if (searchInput && searchInput !== '') {
            const updatedList = [...optionsList].filter((listItem) => {
                const filterClean = searchInput.toLowerCase().trim() || '';
                const titleClean = listItem.toLowerCase().trim();
                const isOptionValid = titleClean.indexOf(filterClean) !== -1;
                return isOptionValid;
            });
            return updatedList;
        }
        return optionsList;
    }, [searchInput, optionsList]);
    useEffect(() => {
        const timer = setTimeout(() => {
            triggerSearch(searchInput);
        }, delay);
        return () => clearTimeout(timer);
    }, [delay, searchInput, onSearch, triggerSearch]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        var _a;
        if (searchInput && searchInput === '') {
            setFocused(false);
        }
        if (((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value) === '') {
            setFocused(false);
        }
    });
    return {
        handleEnter,
        inputRef,
        handleInputChange,
        handleClear,
        handleClickOptions,
        isFocused,
        filteredList,
    };
};
//# sourceMappingURL=useFormSearchWithDropdown.js.map